import React from "react";
import { Field } from "redux-form";
import { textInput, RoleSelectField } from '../../../../shared/form-elements'

class InviteUserFields extends React.Component {
  render() {
    const { fields, editForm, roles, listData, deleteListItemAction, selectListItem } = this.props;
    const removeName = (index, invited_users) => {
      fields.remove(index);
    };
    
    return (
      fields.map((invited_users, index) => {
        return (
          <div key={index} className={index + "findClass_types row"} style={{ flex: 0.95 }}>
            <div className="col-lg-8 col-md-7">
              <Field
                name={`${invited_users}.email`}
                type="text"
                component={textInput}
                label=""
                placeholder="Email Address"
                input_class_name={'btn-outline-gray form-control'}
                listData={listData}
                autoComplete="off"
                deleteListItemAction={deleteListItemAction}
                selectListItem={selectListItem}
              />
            </div>
            <div className="col-lg-4 col-md-5 dropdown_option pl-lg-2">
              <Field
                name={`${invited_users}.workspace_role_id`}
                component={RoleSelectField}
                options={roles?.workspace_roles}
                selectProperText={true}
                label=""
                blank_label="Select Role"
                exclude_blank_option={true}
                input_class_name={'btn-outline-gray role_select_options'}
              />
            </div>
          </div>
        );
      })
    );
  }
}

export default InviteUserFields;
